// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"ShareButtons-module--share-container--1vxJ0","iconContainer":"ShareButtons-module--icon-container--3FnVs"};